export enum DateDetails {
    Month = 'month',
    Year = 'year',
    Decade = 'decade',
    Century = 'century',
}
